import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';
import * as moment from 'moment';
import * as debug from 'debug';

/**
 * Generated class for the FormatDatetimePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'formatSecondsToMinutes',
})
export class FormatSecondsToMinutesPipe implements PipeTransform {
  log = debug('app:FormatSecondsToMinutesPipe');

  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: number, ...args) {
    if (value === null || value === 0) {
      return '0:00';
    } else {
      let d = value;
      var h = Math.floor(d / 3600);
      var m = Math.floor((d % 3600) / 60);

      var hDisplay = h > 0 ? h + ':' : '0:';
      var mDisplay = m > 0 ? m : '00';

      let time = hDisplay + mDisplay;
      if (h === 0 && m === 0) {
        return '0:00';
      } else {
        return time;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/format-seconds-minutes/format-seconds-minutes.ts